import React from 'react';

/*
 * CourierSatchel
 * A small original field-kit satchel — the courier's bag that "carries" the
 * technical toolkit. Decorative (aria-hidden). Reusable via `className` /
 * `width`. Drawn in the Meadow Morning palette to sit beside the toolkit
 * heading without reading as a scrapbook item.
 */
function CourierSatchel({ className = '', width = 60 }) {
  return (
    <svg
      className={className}
      width={width}
      height={width * 0.9}
      viewBox="0 0 72 66"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* strap */}
      <path
        d="M14 24C14 12 24 6 36 6s22 6 22 18"
        stroke="#8a6b3c"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      {/* bag body */}
      <rect x="8" y="22" width="56" height="36" rx="7" fill="#e7ecdf" stroke="#7d9a73" strokeWidth="2.4" />
      {/* flap */}
      <path
        d="M8 30v-2a6 6 0 0 1 6-6h44a6 6 0 0 1 6 6v10c0 3-2 5-5 5H13c-3 0-5-2-5-5v-8z"
        fill="#a8be9a"
        stroke="#7d9a73"
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
      {/* buckle */}
      <rect x="31" y="38" width="10" height="9" rx="2" fill="#d6a65e" stroke="#b9863c" strokeWidth="1.6" />
      {/* side pocket seams */}
      <path d="M20 47v8M52 47v8" stroke="#7d9a73" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default CourierSatchel;
